import { render } from "./SettingsPan.vue?vue&type=template&id=0342b0b5&ts=true"
import script from "./SettingsPan.vue?vue&type=script&lang=ts"
export * from "./SettingsPan.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__